import { Icon, IconButton, Stack, Typography } from '@common-components';
import { AutoAwesomeOutlined, Close, Pause, PlayArrow } from '@icons';

interface AIBubbleHeaderProps {
  onClose: () => void;
  togglePause: () => void;
  isPaused: boolean;
  isFinished: boolean;
}

export function AIBubbleHeader({ onClose, isPaused, togglePause, isFinished }: AIBubbleHeaderProps) {
  return (
    <Stack
      direction="row"
      position="sticky"
      top={0}
      justifyContent="space-between"
      alignItems="center"
      height={48}
      bgcolor="green.300"
      p={1}
    >
      <Stack direction="row">
        <Icon component={AutoAwesomeOutlined} sx={{ fontSize: 16, mr: 1, alignSelf: 'center' }} />
        <Typography variant="h4">AI Orchestrator</Typography>
      </Stack>
      <Stack direction="row">
        {!isFinished && (
          <IconButton
            icon={isPaused ? PlayArrow : Pause}
            onClick={togglePause}
            variant="text"
            color="secondary"
            bgcolor="green.300"
          />
        )}
        <IconButton icon={Close} onClick={onClose} variant="text" color="secondary" bgcolor="green.300" />
      </Stack>
    </Stack>
  );
}
